import { render } from "./RoundStatisticsModal.vue?vue&type=template&id=104732b2&scoped=true"
import script from "./RoundStatisticsModal.vue?vue&type=script&lang=js"
export * from "./RoundStatisticsModal.vue?vue&type=script&lang=js"

import "./RoundStatisticsModal.vue?vue&type=style&index=0&id=104732b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104732b2"]])

export default __exports__